/**
 * One entry per section of the Internal Tools tab.
 *
 * Unlike {@link ../constants/adminSections}, there are no per-section permission
 * slugs: Internal Tools is gated wholesale — the page refuses anyone who is not a
 * Strawhat `admin:super-user` before it renders a tab strip at all — so a section
 * either exists everywhere the page does, or is hidden by the deploy stage.
 */
export interface InternalToolsSectionDefinition {
  /** Stable id, used as the tab value and the `?section=` query parameter. */
  id: string;
  label: string;
  /**
   * Sections that must not exist in production. Today only demo agency setup,
   * whose API is unmounted in prod as well.
   */
  nonProdOnly: boolean;
}

export const INTERNAL_TOOLS_SECTIONS: readonly InternalToolsSectionDefinition[] =
  [
    {
      id: 'demo-environments',
      label: 'Demo Sandboxes',
      nonProdOnly: true,
    },
    {
      id: 'agencies-users',
      label: 'Agencies & Users',
      nonProdOnly: false,
    },
    {
      id: 'product-updates',
      label: 'Product Updates',
      nonProdOnly: false,
    },
    {
      id: 'stedi',
      label: 'Stedi',
      nonProdOnly: false,
    },
    {
      id: 'evv',
      label: 'EVV',
      nonProdOnly: false,
    },
  ];

/**
 * The sections this deploy stage gets, in tab order.
 *
 * Takes the answer rather than asking for it: the caller passes the stage
 * predicate so this stays a pure function of its argument, testable without
 * stubbing the deploy-stage module.
 */
export function visibleInternalToolsSections(
  isNonProd: boolean
): InternalToolsSectionDefinition[] {
  return INTERNAL_TOOLS_SECTIONS.filter(
    section => !section.nonProdOnly || isNonProd
  );
}
